import {
  INITIAL,
  REQUEST,
  SUCCESS,
  FAILURE,
  PRICE_REQUEST_MESSAGE_START,
  PRICE_REQUEST_MESSAGE_SUCCESS,
  PRICE_REQUEST_MESSAGE_FAILURE
} from '../actionTypes';

const initialState = {
  state: INITIAL,
  data: {}
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PRICE_REQUEST_MESSAGE_START:
      return { state: REQUEST, data: payload };
    case PRICE_REQUEST_MESSAGE_SUCCESS:
      return { state: SUCCESS, data: payload };
    case PRICE_REQUEST_MESSAGE_FAILURE:
      return { state: FAILURE, data: payload };
    default:
      return state;
  }
};
